<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
/* eslint-disable */
  /* 使用时间戳引入初始化js start */
function getTimestamp (msec) {
  msec = msec || 1
  return parseInt((new Date()).valueOf() / msec, 10)
}
function loadScript (src, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  cb = cb || function () {}

  script.type = 'text/javascript'
  script.src = src

  if (!('onload' in script)) {
    script.onreadystatechange = function () {
      if (this.readyState !== 'complete' && this.readyState !== 'loaded') return
      this.onreadystatechange = null
      cb(script)
    }
  }

  script.onload = function () {
    this.onload = null
    cb(script)
  }

  head.appendChild(script)
}
/* 使用时间戳引入初始化js end */
//使用时间戳引入初始化js
// let url = 'https://cstaticdun.126.net/load.min.js' + '?t=' + getTimestamp(60 * 1000) // 时长1分钟，建议时长分钟级别
// loadScript(url, function () {})
export default {
  name: 'App'
}
</script>

<style lang="scss">
//引入特殊字体
@import './static/font/font.css';
// 引入样式重置
@import './static/scss/config/_reset.scss';
// 引入动画配置
@import './static/scss/config/_animate.scss';
// 引入常用设置
@import './static/scss/config/_setting.scss';
// mint样式覆盖
@import './static/scss/config/_mint.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue